<template>
  <div class="white_bg">
    <article v-html="agreement" class="article agreementArticle paddingV18 paddingH12"> </article>
  </div>
</template>

<script>
import bizTypeEnum from "@data/bizTypeEnum";
import atlasApi from "@comp/atlas/atlasApi";
import datumApi from "@comp/datum/datumApi";
import courseApi from "@pages/course/courseApi";
import shopApi from "@comp/shop/shopApi";

import appHelper from "@util/appHelper";
import consoleApi from "@comp/platformApi/consoleApi";

export default {
  name: "agreement_for_biz",
  data(){
    return{
      agreement:'',
    }
  },
  mounted() {
    const bizType = this.$route.params.bizType;
    const bizId = this.$route.params.bizId;
      consoleApi.log('bizType: ' + bizType);
      consoleApi.log('bizId: ' + bizId);
    this.getInfo(bizType, bizId);
  },
  methods: {
    getInfo(bizType, bizId) {
        const me = this;
        if (bizType == bizTypeEnum.ATLAS.code)
        {
            atlasApi.getItem(bizId, (atlasItem) => {
                me.agreement = atlasItem.agreement;
            });
        }
        else if (bizType == bizTypeEnum.DATUM.code)
        {
            datumApi.getItem(bizId, (datumItem) => {
                me.agreement = datumItem.agreement;
            });
        }
        else if (bizType == bizTypeEnum.VOD.code)
        {
            courseApi.getItem(bizId, (datumItem) => {
                me.agreement = datumItem.agreement;
            });
        }
        else if (bizType == bizTypeEnum.THIRD_PARTY.code)
        {
            shopApi.getGoodsItem(bizId, (datumItem) => {
                me.agreement = datumItem.agreement;
            });
        }
        else
        {
            appHelper.showHint('找不到匹配的业务类型');
        }
    }
  }
}
</script>

<style scoped>

</style>